import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class DeviceIdService {
  private readonly storageKey = 'deviceId';
  constructor() { }

  getDeviceId(): string {
    let deviceId = localStorage.getItem(this.storageKey);
    if (!deviceId) {
      deviceId = uuidv4(); // Generate a new UUID
      localStorage.setItem(this.storageKey, deviceId);
    }
    return deviceId;
  }
  
}
